import React, { useEffect, useState } from "react";
import NotificationItem from "./components/NotificationItem";
import NoNotificationFound from "../../components/Candidates/noNotificationFound";
import _ from "lodash";
import PaginationComponent from "../../components/common/Pagination";
import { Button, FlashMessage, Modal } from "../../components/common";
import notificationServices from "../../services/notification.services";
import searchAndConnectServices from "../../services/searchAndConnect.services";
import { updateNotificationCount } from "../../reducers/auth/session.reducer";
import { useDispatch, useSelector } from "react-redux";
import { rootReducersState } from "../../reducers";
import { Link } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import Image from "../../components/common/Image";
import candidateServices from "../../services/candidate.services";
import { useForm } from "react-hook-form";
import RecommendationType from "../../components/ProfileViewNew/components/RecommendationType";
import {
  getPrefillWriteTextFromAskRequest,
  getUserDisplayJobTitle,
  ASK_REQUEST_PLACEHOLDER_TEXTS,
} from "../../utils/helper";

const defaultFilter = {
  page: 1,
  pageSize: 10,
  isCompany: 1,
};

const ConnectionNotification = () => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [filter, setFilter] = useState(defaultFilter);
  const [notificationList, setNotificationList] = useState([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [pagination, setPagination] = useState<any>({});
  const [key, setKey] = useState<number>(0);
  const [pendingConnections, setPendingConnections] = useState<Record<number, number>>({});
  const [viewRecommendationModal, setViewRecommendationModal] = useState<boolean>(false);
  const [currentRecommendation, setCurrentRecommendation] = useState<any>(null);
  const sessionReducer = useSelector(
    ({ session }: rootReducersState) => session
  );

  const notificationCount = _.get(sessionReducer, "currentUser.notificationCount", 0) > 0 ? _.get(sessionReducer, "currentUser.notificationCount", 0) : 0;
  const companyNotificationCount = _.get(sessionReducer, "currentUser.companyNotificationCount", 0) > 0 ? _.get(sessionReducer, "currentUser.companyNotificationCount", 0) : 0;
  const [openReviseEditModal, setOpenReviseEditModal] = useState(false)
  const [editRecommendationText, setEditRecommendationText] = useState('');
  const [notificationWriteModal, setNotificationWriteModal] = useState(false);
  const [notificationWriteText, setNotificationWriteText] = useState("");
  const [notificationRelationshipValue, setNotificationRelationshipValue] =
    useState("");
  const [notificationRecommendationTypeError, setNotificationRecommendationTypeError] =
    useState("");
  const [notificationWriteLoading, setNotificationWriteLoading] = useState(false);
  const sessionUserId = _.get(sessionReducer, "currentUser.id");
  const {
    register,
    formState: { errors },
  } = useForm();
  // const {
  //   list: { notificationData, loading, pagination },
  // } = useSelector(({ notification }: any) => notification);

  // useEffect(() => {
  //   dispatch(notificationListRequest({ page, pageSize: 10 }));
  // }, [dispatch, page]);

  const _handlePaginationChange = (value: number) => {
    setPage(value);
    let payload = {
      ...defaultFilter,
      page: value
    }
    setFilter(filter);
    fetchApi(payload)
  };

  // const _handleAllClear = () => {
  //   dispatch(clearAllNotificationRequest());
  //   if (!loading) dispatch(notificationListRequest({ page, pageSize: 10 }));
  // };

  const _handleAllClear = async () => {
    let isCompany = 1
    if (window?.location?.pathname !== '/notifications') isCompany = 2
    try {
      setLoading(true)
      const result = await notificationServices.clearAllNotification({ isCompany: isCompany });

      if (result.flag) {
        // eslint-disable-next-line array-callback-return
        notificationList.map((item: any) => { item.is_read = 0 });
        setNotificationList(notificationList)
        setKey((key) => key + 1)
        setLoading(false)
      } else {
        setLoading(false)
        FlashMessage(result.message, "error");
      }
    } catch (error) {
      FlashMessage(error?.message, "error");
    }
  };

  useEffect(() => {
    setFilter(defaultFilter);
    fetchApi(filter)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const fetchApi = async (payload) => {
    if (window?.location?.pathname !== '/notifications') {
      payload = { ...payload, isCompany: 2 }
    }
    try {
      setLoading(true)
      const result = await notificationServices.list(payload);

      if (result.flag) {
        const list = _.get(result, 'data.data', []);
        setNotificationList(list)
        setPagination(_.get(result, 'data.pagination', {}))
        setLoading(false)
        fetchPendingConnections(list)
      } else {
        setLoading(false)
        FlashMessage(result.message, "error");
      }
    } catch (error) {
      FlashMessage(error?.message, "error");
    }
  };

  const fetchPendingConnections = async (notifications = []) => {
    const hasConnectionRequest = (notifications || []).some(
      (item) =>
        Number(_.get(item, "notification_type_id", 0)) === 2 &&
        /connection request/i.test(String(_.get(item, "payload", "")))
    );
    if (!hasConnectionRequest) {
      setPendingConnections({});
      return;
    }

    try {
      const result = await searchAndConnectServices.getConnectionRequests({
        type: "received",
        page: 1,
        pageSize: 100,
      });
      const list = _.get(result, "data.data", []);
      const pendingMap = (list || []).reduce((acc, item) => {
        const userId = Number(_.get(item, "requester.id"));
        const connectionId = Number(_.get(item, "id"));
        if (userId && connectionId) {
          acc[userId] = connectionId;
        }
        return acc;
      }, {} as Record<number, number>);
      setPendingConnections(pendingMap);
    } catch (error) {
      setPendingConnections({});
    }
  };

  const handleConnectionResolved = (userId) => {
    const parsedId = Number(userId);
    if (!parsedId) return;
    setPendingConnections((prev) => {
      const next = { ...prev };
      delete next[parsedId];
      return next;
    });
  };

  const handleClear = (id) => {
    const index = notificationList.findIndex((item: any) => item.id === id);
    notificationList.splice(index, 1);
    setNotificationList(notificationList)
    setKey((key) => key + 1)
    const payload = {
      notificationCount: notificationCount,
      companyNotificationCount: companyNotificationCount
    }
    if (window.location.pathname !== '/notifications') {
      payload['companyNotificationCount'] = companyNotificationCount === 0 ? companyNotificationCount : companyNotificationCount - 1;
    } else {
      payload['notificationCount'] = notificationCount === 0 ? notificationCount : notificationCount - 1;
    }
    dispatch(updateNotificationCount(payload));
  }

  const handleRead = (id) => {
    // eslint-disable-next-line array-callback-return
    notificationList.map((item: any) => { if (item.id === id) item.is_read = 0 });
    setNotificationList(notificationList)
    setKey((key) => key + 1)
    const payload = {
      notificationCount: notificationCount,
      companyNotificationCount: companyNotificationCount
    }
    if (window.location.pathname !== '/notifications') {
      payload['companyNotificationCount'] = companyNotificationCount === 0 ? companyNotificationCount : companyNotificationCount - 1;
    } else {
      payload['notificationCount'] = notificationCount === 0 ? notificationCount : notificationCount - 1;
    }
    dispatch(updateNotificationCount(payload));
  }


  const recommendationIdFromNotification = (n: any) =>
    _.get(n, "recommendation_id") || _.get(n, "recommendation.id");

  const hasRealRecommendationText = (rec: any) => {
    const t = String(rec?.recommendation_text || "").trim();
    if (!t) return false;
    return !ASK_REQUEST_PLACEHOLDER_TEXTS.test(t);
  };

  const approveOrDeclineRecommendation = async (status: boolean) => {
    try {
      if (!currentRecommendation) {
        FlashMessage("No recommendation selected", "error");
        return;
      }
      const payload = {
        recommendation_id: recommendationIdFromNotification(currentRecommendation),
        flag: status,
      };
      const result = await candidateServices.approveRecommendations(payload);

      if (result.flag) {
        FlashMessage(
          `Recommendation ${status ? "accepted" : "declined"} successfully`
        );
        setViewRecommendationModal(false);
        setCurrentRecommendation(null);
        fetchApi(filter);
      } else {
        FlashMessage(result.message, "error");
      }
    } catch (error) {
      FlashMessage("Something went wrong!", "error");
    }
  };

  const declineIncomingRecommendationRequest = async () => {
    try {
      const rec = currentRecommendation?.recommendation;
      if (!rec?.id) {
        FlashMessage("No recommendation selected", "error");
        return;
      }
      const result = await candidateServices.respondRecommendationRequest({
        recommendation_id: rec.id,
        action: "decline",
      });
      if (result.flag) {
        FlashMessage("Recommendation request declined successfully");
        setViewRecommendationModal(false);
        setCurrentRecommendation(null);
        fetchApi(filter);
      } else {
        FlashMessage(result.message, "error");
      }
    } catch (error) {
      FlashMessage("Something went wrong!", "error");
    }
  };

  const submitNotificationWriteRecommendation = async () => {
    const rec = currentRecommendation?.recommendation;
    if (!rec?.id) {
      FlashMessage("No recommendation selected", "error");
      return;
    }
    if (!notificationRelationshipValue?.trim()) {
      setNotificationRecommendationTypeError(
        "Please select a recommendation type"
      );
      FlashMessage("Please select how you know this person", "error");
      return;
    }
    setNotificationRecommendationTypeError("");
    if (!notificationWriteText.trim()) {
      FlashMessage("Please write your recommendation", "error");
      return;
    }
    setNotificationWriteLoading(true);
    try {
      const result = await candidateServices.updateRecommendations(rec.id, {
        recommendation_text: notificationWriteText.trim(),
        relationship: notificationRelationshipValue.trim(),
        flag: false,
      });
      if (result.flag) {
        FlashMessage("Recommendation sent successfully");
        setNotificationWriteModal(false);
        setNotificationWriteText("");
        setNotificationRelationshipValue("");
        setViewRecommendationModal(false);
        setCurrentRecommendation(null);
        fetchApi(filter);
      } else {
        FlashMessage(result.message || "Failed to send", "error");
      }
    } catch (error) {
      FlashMessage("Something went wrong!", "error");
    } finally {
      setNotificationWriteLoading(false);
    }
  };

  const notificationCandidateName = currentRecommendation?.user
    ? `${currentRecommendation.user.first_name || ""} ${currentRecommendation.user.last_name || ""}`.trim()
    : "Candidate";

  const notificationWriteCandidateJobTitle = currentRecommendation?.user
    ? getUserDisplayJobTitle(currentRecommendation.user)
    : "";


  const declineReviseRecommendation = async (status: boolean) => {

    try {
      if (!currentRecommendation) {
        FlashMessage("No recommendation selected", "error");
        return;
      }
      const payload = {
        recommendationId: recommendationIdFromNotification(currentRecommendation),
        recommendation_text: editRecommendationText,
        receiver_id: currentRecommendation?.recommendation?.receiver_id,
        flag: status,
      };

      const result = await candidateServices.declineReviseRecommendation(payload);
      if (result.flag) {
        FlashMessage(`Recommendation ${status ? 'updated' : 'declined'} successfully`);
        setViewRecommendationModal(false);
        setOpenReviseEditModal(false);
        setCurrentRecommendation(null);
        fetchApi(filter);
      } else {
        FlashMessage(result.message, "error");
      }
    } catch (error) {
      FlashMessage("Something went wrong!", "error");
    }
  }

  const handleCloseReviseEditModal = () => {
    setOpenReviseEditModal(false);
    setCurrentRecommendation(null);
    setEditRecommendationText("");
  }


  const closeRecommendationModal = () => {
    setViewRecommendationModal(false);
    setCurrentRecommendation(null);
  };

  const rec = currentRecommendation?.recommendation;
  const reqFlag =
    rec?.is_requested === true || rec?.is_requested === 1;
  const mainStatus = String(rec?.main_status ?? "");
  /** B: someone asked you to write (row still pending, you are receiver). */
  const isInviteToWrite =
    !!rec &&
    reqFlag &&
    mainStatus === "2" &&
    Number(rec.receiver_id) === Number(sessionUserId);
  /** A: someone wrote text for you; you must accept before it moves to Received + Add to profile. */
  const isAwaitingMyApproval =
    !!rec &&
    !reqFlag &&
    Number(rec.receiver_id) === Number(sessionUserId) &&
    String(rec.status) === "1" &&
    mainStatus === "1" &&
    hasRealRecommendationText(rec);
  const isRevisePending =
    !!rec &&
    Number(rec?.is_revise) === 1 &&
    String(rec?.revise_status) !== "2";

  return (
    <div className="max-container">
      <div className="connection-notification-wrapper notifications-page">
        {!_.isEmpty(notificationList) && (
          <div className="notifications-toolbar">
            <Link
              onClick={_handleAllClear}
              className="notifications-mark-all cursor-pointer"
              underline="none"
            >
              Mark all as read
            </Link>
          </div>
        )}
        <div className="notification-feed" key={key}>
          {loading ? (
            [1, 2, 3, 4, 5].map((row) => (
              <div className="notification-item notification-item-skeleton" key={row}>
                <div className="notification-item-indicator" />
                <Skeleton variant="circle" width={52} height={52} />
                <div className="notification-item-content">
                  <Skeleton variant="text" width="80%" height={22} />
                  <Skeleton variant="text" width="45%" height={18} />
                </div>
                <div className="notification-item-meta">
                  <Skeleton variant="text" width={28} height={16} />
                </div>
              </div>
            ))
          ) : _.isEmpty(notificationList) ? (
            <NoNotificationFound
              label="notifications"
              message="You don't have any notifications yet."
            />
          ) : (
            <>
              {notificationList.map((notification) => (
                <NotificationItem
                  key={notification.id}
                  notification={notification}
                  pendingConnectionId={
                    pendingConnections[Number(_.get(notification, "connected_user_id"))]
                  }
                  handleClear={(e) => {
                    handleClear(e);
                  }}
                  handleRead={(e) => {
                    handleRead(e);
                  }}
                  onConnectionResolved={handleConnectionResolved}
                  setViewRecommendationModal={setViewRecommendationModal}
                  setCurrentRecommendation={setCurrentRecommendation}
                />
              ))}
              <div className="notifications-pagination">
                <PaginationComponent
                  count={_.get(pagination, "totalPages", 0)}
                  page={page}
                  variant="outlined"
                  color="secondary"
                  onChange={(value) => _handlePaginationChange(value)}
                />
              </div>
            </>
          )}
        </div>

      </div>

      {/* view recommendation modal */}

      <Modal
        visible={viewRecommendationModal}
        onClose={closeRecommendationModal}
        className={`candidate-profile-modal view-recommendation-modal`}
        title="View recommendation"
      >
        <div className="modal-body-wrapper">
          <div className="user-info-wrapper">
            <div className="user-icon">
              <Image
                src={currentRecommendation?.user?.profile_image || ""}
                alt="user"
              />
            </div>
            <div className="user-info">
              <p>
                {currentRecommendation?.user?.first_name}{" "}
                {currentRecommendation?.user?.last_name}
                {notificationWriteCandidateJobTitle ? (
                  <span className="recommendation-user-job-title">
                    {" "}
                    {notificationWriteCandidateJobTitle}
                  </span>
                ) : null}
              </p>
            </div>
          </div>
          {isRevisePending ? (
            <div className="message-wrapper">
              <b>Message:</b>
              <p>
                {currentRecommendation?.recommendation?.revise_recommdation_text}
              </p>
            </div>
          ) : (
            <>
              <div className="message-wrapper">
                <b>Type:</b>
                <p>{currentRecommendation?.recommendation?.relationship}</p>
              </div>
              <div className="message-wrapper">
                <b>Message:</b>
                <p>
                  {isInviteToWrite &&
                    !hasRealRecommendationText(currentRecommendation?.recommendation)
                    ? "—"
                    : currentRecommendation?.recommendation?.recommendation_text}
                </p>
              </div>
            </>
          )}

          {isRevisePending ? (
            <div className={`btn-wrapper ${!isRevisePending ? "write-recommendation-btn" : ""}`}>
              <Button
                color="secondary"
                onClick={() => declineReviseRecommendation(false)}
              >
                Decline
              </Button>
              <Button
                color="primary"
                onClick={() => {
                  setEditRecommendationText(
                    currentRecommendation?.recommendation
                      ?.revise_recommdation_text
                  );
                  setOpenReviseEditModal(true);
                  setViewRecommendationModal(false);
                }}
              >
                Edit
              </Button>
            </div>
          ) : isInviteToWrite ? (
            <div className="btn-wrapper write-recommendation-btn">
              <Button
                color="secondary"
                onClick={() => declineIncomingRecommendationRequest()}
              >
                Decline
              </Button>
              <Button
                color="primary"
                onClick={() => {
                  const r = currentRecommendation?.recommendation;
                  setNotificationWriteText(getPrefillWriteTextFromAskRequest(r));
                  setNotificationRelationshipValue(
                    String(r?.relationship || "").trim()
                  );
                  setNotificationRecommendationTypeError("");
                  setViewRecommendationModal(false);
                  setNotificationWriteModal(true);
                }}
              >
                Write a recommendation
              </Button>
            </div>
          ) : isAwaitingMyApproval ? (
            <div className="btn-wrapper">
              <Button
                color="secondary"
                onClick={() => approveOrDeclineRecommendation(false)}
              >
                Decline
              </Button>
              <Button
                color="primary"
                onClick={() => approveOrDeclineRecommendation(true)}
              >
                Accept
              </Button>
            </div>
          ) : null}
        </div>
      </Modal>

      <Modal
        visible={notificationWriteModal}
        onClose={() => {
          setNotificationWriteModal(false);
          setNotificationWriteText("");
          setNotificationRelationshipValue("");
          setNotificationRecommendationTypeError("");
          setNotificationWriteLoading(false);
        }}
        className="candidate-profile-modal recommendation-modal"
        title="Write recommendation"
        size="large"
      >
        <div className="modal-body-wrapper">
          <div className="form-wrapper">
            {currentRecommendation?.user && (
              <div className="profile-wrapper">
                <div className="profile-content">
                  <div className="profile-icon">
                    <Image
                      src={currentRecommendation.user.profile_image || ""}
                      alt="profile"
                      width="100%"
                    />
                  </div>
                  <b>
                    {currentRecommendation.user.first_name}{" "}
                    {currentRecommendation.user.last_name}
                    {notificationWriteCandidateJobTitle ? (
                      <span className="recommendation-user-job-title">
                        {" "}
                        {notificationWriteCandidateJobTitle}
                      </span>
                    ) : null}
                  </b>
                </div>
              </div>
            )}
            <RecommendationType
              label="How do you know each other?*"
              placeholder="Select recommendation type"
              value={notificationRelationshipValue}
              onChange={(val) => {
                setNotificationRelationshipValue(val);
                setNotificationRecommendationTypeError("");
              }}
              errors={errors}
              candidateName={notificationCandidateName}
              register={register}
              errorMessage={notificationRecommendationTypeError}
            />
            <div className="form-group">
              <label
                className="form-label"
                htmlFor="notification-write-rec"
              >
                Write a recommendation*
              </label>
              <textarea
                id="notification-write-rec"
                className="form-control"
                rows={6}
                value={notificationWriteText}
                onChange={(e) => setNotificationWriteText(e.target.value)}
                placeholder="Write your recommendation here…"
              />
            </div>
          </div>
          <div className="btn-wrapper notification-write-rec-actions">
            <Button
              type="button"
              color="secondary"
              onClick={() => {
                setNotificationWriteModal(false);
                setNotificationWriteText("");
                setNotificationRelationshipValue("");
                setNotificationRecommendationTypeError("");
                setNotificationWriteLoading(false);
              }}
            >
              Cancel
            </Button>
            <Button
              type="button"
              loading={notificationWriteLoading}
              onClick={() => submitNotificationWriteRecommendation()}
            >
              <span>Send</span>
            </Button>
          </div>
        </div>
      </Modal>
      <Modal
        className="candidate-profile-modal recommendation-modal"
        isOpen={openReviseEditModal}
        onClose={() => {
          handleCloseReviseEditModal();
        }}
        title="Edit a Recommendation"
        visible={openReviseEditModal}
        size="large"
      >
        <div className="modal-body-wrapper">
          <div className="form-wrapper">
            <div className="profile-wrapper">
              <div className="profile-content">
                <div className="profile-icon">
                  <Image
                    src={currentRecommendation?.user?.profile_image || ""}
                    alt="profile"
                    width="100%"
                  />
                </div>
                <b>
                  {currentRecommendation?.user?.first_name +
                    " " +
                    currentRecommendation?.user?.last_name}
                </b>
              </div>
            </div>
            <div className="form-group">
              <label
                htmlFor="recommendation_description"
                className="form-label"
              >
                Edit recommendation
              </label>
              <textarea
                id="recommendation_description"
                placeholder="Write your message here..."
                className="form-control"
                rows={4}
                value={editRecommendationText || ""}
                onChange={(e) => setEditRecommendationText(e.target.value)}
              ></textarea>
            </div>
          </div>
          <div className="btn-wrapper">
            <Button
              onClick={() => {
                handleCloseReviseEditModal();
              }}
              type="button"
              color="secondary"
              style={{ padding: "12px 20px" }}
            >
              Cancel
            </Button>
            <Button
              onClick={() => declineReviseRecommendation(true)}
              type="button"
              style={{ padding: "12px 20px" }}
            >
              Update
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ConnectionNotification;
